import { Observable } from "rxjs";

export interface LeadFinance {
  name: string;
  surname: string;
  full_name?: string;
  phone:any;
  email:any;
  sentToBuyer?: boolean;
  needToSend?: boolean;
  id?: string;
  offerId?: any;
  offer_id?:any;
  time?: any;
  owner?: any;
  response?:string
}

export abstract class LeadFinanceData {
  abstract getLeadsFinance(pagination, filter, order);
  abstract getLeadFinance(id: string);
  abstract sendLeadFinance( id: string);
}
